import * as moment from "moment-timezone";

const base = {
  format: "YYYY-MM-DD",
  tz: "America/Tegucigalpa",
};

export const date = (
  date: Date | moment.Moment | string,
  opts = {}
): string => {
  const momentDate = moment(date);
  const mergedOptions = Object.assign({}, base, opts);

  const convertedDate = momentDate.tz(mergedOptions.tz);
  return convertedDate.format(mergedOptions.format);
};

export const toUTC = (date) => moment(date).tz("UTC").toISOString();
export const toDate = (
  date: Date | moment.Moment | string,
  tz?
): moment.Moment => moment(date).tz(tz || base.tz);
export const now = (tz?) => moment().tz(tz || base.tz);
